"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressSearch = void 0;
var _react = require("react");
var _useAppDispatch = require("../useAppDispatch");
var _useQuestionSelectionActions = require("./useQuestionSelectionActions");
var _useAppSelector2 = require("../useAppSelector");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
var _useFormReducer = require("./useFormReducer");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _useManualPromise = require("../app/useManualPromise");
const useAddressSearch = (question, initialState, selection) => {
  var _useAppSelector;
  //-----------------Generic Logic for Address Search----------------------
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const addressSuggestions = (_useAppSelector = (0, _useAppSelector2.useAppSelector)(_productCatalogSelectors.selectAddressSuggestions)) !== null && _useAppSelector !== void 0 ? _useAppSelector : [];
  const {
    state,
    dispatch: formDispatch,
    ACTION_TYPES
  } = (0, _useFormReducer.useFormReducer)(initialState);
  const handleSelectionRemoval = (0, _react.useCallback)((value, comparison) => {
    if (selection && value !== comparison) {
      removeSelection(selection);
    }
  }, [selection]);
  const onFieldChange = (field, value) => {
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: field,
        value
      }
    });
    handleSelectionRemoval(value, state[field]);
  };
  const onSuggestionsSelect = choice => {
    if (choice.hasEmptyResults) return;
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: 'address',
        value: choice.text
      }
    });
  };
  const filteredSuggestions = (0, _react.useMemo)(() => addressSuggestions.map(addressSuggestion => ({
    text: addressSuggestion.name
  })), [addressSuggestions]);
  const {
    createPromise,
    resolve,
    status
  } = (0, _useManualPromise.useManualPromise)();
  const onFilter = (0, _react.useCallback)(value => {
    var _ref;
    if (value.length >= ((_ref = question.minCharacters) !== null && _ref !== void 0 ? _ref : 3)) {
      dispatch((0, _productCatalogActions.fetchAddressSuggestions)(value));
    }
    return createPromise();
  }, [question, dispatch, _productCatalogActions.fetchAddressSuggestions]);

  // --------------------------Effects-----------------------------------
  (0, _react.useEffect)(() => {
    //This effect handles the asynchronous resolution of the suggestions for search fields
    //It resolves the promise when the suggestions are available
    //This handling is necessary because of a Source Library limitation

    if (filteredSuggestions.length && status === 'pending') {
      resolve(filteredSuggestions);
    }
  }, [filteredSuggestions, status]);

  // ----------------------------------------------------------------------

  return {
    state,
    formDispatch,
    ACTION_TYPES,
    onFieldChange,
    onSuggestionsSelect,
    addressSuggestions,
    filteredSuggestions,
    onFilter: onFilter
  };
};
exports.useAddressSearch = useAddressSearch;